import React from "react";
import { Popover } from 'antd';
import s from './index.module.css';

import HCX from '../../asset/qrCode/hcx.jpg';
import HSX from '../../asset/qrCode/hsx.jpg';
import QCX from '../../asset/qrCode/qcx.jpg';
import ZNX from '../../asset/qrCode/znx.jpg';
import HX from '../../asset/qrCode/hx.jpg';
import ZYX from '../../asset/qrCode/zyx.png';
import XFQ from '../../asset/qrCode/xfq.jpg';

const Foot = () => {
    const friendlyLinks = [
        { name: '国家市场监督管理总局', url: 'http://www.samr.gov.cn/' },
        { name: '甘肃省市场监督管理局', url: 'http://scjg.gansu.gov.cn/' },
        { name: '庆阳市市场监管局', url: 'http://scjg.zgqingyang.gov.cn/' },
        { name: '庆阳市市场监管局–西峰分局', url: '', qrCode: XFQ },
        { name: '镇原县市场监管局', url: '', qrCode: ZYX },
        { name: '宁县市场监管局', url: '' },
        { name: '环县市场监管局', url: '', qrCode: HX },
        { name: '华池县市场监管局', url: '', qrCode: HCX },
        { name: '庆城县市场监管局', url: '', qrCode: QCX },
        { name: '正宁县市场监管局', url: '', qrCode: ZNX },
        { name: '合水县市场监管局', url: '', qrCode: HSX }
    ];

    return (
        <div className={s.footer}>
            {/* 友情链接模块 */}
            <div className={s.friendlyLinks}>
                <div className={s.friendlyLinksContainer}>
                    <span className={s.friendlyLinksTitle}>相关链接</span>
                    <div className={s.friendlyLinksContent}>
                        {friendlyLinks.map((link, index) => (
                            <React.Fragment key={index}>
                                {link.url ? (
                                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                                        {link.name}
                                    </a>
                                ) : (
                                    <Popover
                                        content={
                                            <div className={s.qrCodePopover}>
                                                <img src={link.qrCode || ''} alt={link.name} className={`${s.qrCodePopoverImg} ${link.qrCode ? '' : s.disableShow}`} />
                                                <p className={s.qrCodePopoverText}>{link.name}</p>
                                            </div>
                                        }
                                        trigger="click"
                                        placement="top"
                                        overlayClassName={s.popoverRounded}
                                    >
                                        <span className={s.disabledLink}>{link.name}</span>
                                    </Popover>
                                )}
                                {index < friendlyLinks.length - 1 && <span className={s.separator}>|</span>}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer 内容 */}
            <div className={s.footerContent}>
                <div className={s.footerContainer}>
                    {/* 左侧二维码 */}
                    <div className={s.footerLeft}>
                        <div className={s.qrCodeItem}>
                            <img src="/gzh.jpeg" alt="微信公众号" className={s.qrCodeImg}/>
                            <span className={s.qrCodeLabel}>微信公众号</span>
                        </div>
                        <div className={s.qrCodeItem}>
                            <img src="/xcx.jpg" alt="机构端小程序" className={s.qrCodeImg}/>
                            <span className={s.qrCodeLabel}>微信小程序</span>
                        </div>
                    </div>

                    {/* 中间信息 */}
                    <div className={s.footerCenter}>
                        <p className={s.footerInfo}>版权所有: 庆阳市市场监管局</p>
                        <p className={s.footerInfo}>地址：甘肃省庆阳市西峰区朔州西路1号交警大厦8楼</p>
                        {/*<p className={s.footerInfo}>技术支持：庆阳市科飞扬技术有限公司 | 热线电话：0934-8212672</p>*/}
                        <p className={s.footerInfo}>
                            备案序号：
                            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">陇ICP备2021001594号-5</a>
                            <span className={s.separator}> | </span>
                            <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62100002000110" target="_blank" rel="noopener noreferrer">甘公网安备62100002000110号</a>
                        </p>
                    </div>

                    {/* 右侧图标 */}
                    <div className={s.footerRight}>
                        <img src="/dzjg.png" alt="电子政务" className={s.footerIcon}/>
                        <img src="/jiucuo.png" alt="纠错举报" className={s.footerIcon}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Foot;
